import { styled } from '@mui/material';

import { ChkButton } from '../ChkButton/ChkButton';
import { CHK_BUTTON_VARIANT } from '../ChkButton/ChkButton.constants';

import type { ChkProceedWithBankButtonProps } from './ChkProceedWithBankButton.types';

export function ChkProceedWithBankButton({
  bankName,
  children,
  iconUrl,
  redirectUrl,
  testId,
  ...rest
}: ChkProceedWithBankButtonProps) {
  return (
    <Button
      endIcon={
        Boolean(iconUrl) && <Icon src={iconUrl} alt="" draggable={false} />
      }
      data-testid={testId}
      href={redirectUrl}
      variant={CHK_BUTTON_VARIANT.CONTAINED}
      {...rest}
    >
      {children}
    </Button>
  );
}

const Button = styled(ChkButton)(({ theme }) => ({
  border: 0,
  borderRadius: theme.borders.borderRadius2,
  marginTop: theme.spacing(4),
  flexWrap: 'wrap',
}));

const Icon = styled('img')(({ theme }) => ({
  marginLeft: theme.spacing(3),
  width: `2.4rem`,
  height: `2.4rem`,
}));
